var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoiconLogoSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4693 3.71647L53.0891 42.3045L55.9648 1.42333",
    stroke: "#DF459C",
    strokeWidth: 4.96753
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4899 5.6119L63.0081 44.6995L95.0495 19.1479",
    stroke: "#0F4CDB",
    strokeWidth: 4.96753
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.991 37.7061L67.6424 53.5557L108.351 58.2846",
    stroke: "#DF459C",
    strokeWidth: 4.96753
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.625 79.5191L64.6799 62.7033L89.9563 94.9622",
    stroke: "#0F4CDB",
    strokeWidth: 4.96753
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4524 106.572L56.2232 66.98L50.8551 107.609",
    stroke: "#DF459C",
    strokeWidth: 4.96753
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6257 103.428L47.3263 64.0199L15.7998 90.2042",
    stroke: "#0F4CDB",
    strokeWidth: 4.96753
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70964 73.2045L42.6844 56.4575L1.87832 52.6626",
    stroke: "#DF459C",
    strokeWidth: 4.96753
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97259 33.5835L45.1174 47.4598L17.5729 17.1146",
    stroke: "#0F4CDB",
    strokeWidth: 4.96753
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoiconLogoSm);
export default __webpack_public_path__ + "static/media/goicon-logo-sm.01003471.svg";
export { ForwardRef as ReactComponent };